










































import { VNode, CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { BreadcrumbItem } from './types';

const cssPrefix = 'sw-breadcrumb';

/**
 * Events:
 * @event item-click `(string | number)`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwBreadcrumb extends SwExtendedVue {
  @Prop({ required: true, type: Array })
  items: BreadcrumbItem[];

  cssPrefix = cssPrefix;

  private onClickItem(item: BreadcrumbItem, index: number) {
    this.$emit('item-click', item.id || index);
  }

  private render(h: CreateElement): VNode {
    return (
      <div class={[`${this.cssPrefix}`, 'sw-flexbox', 'sw-typo-default']}>
      {
        this.items.map<VNode>((item, index) => {
          const slashNode = index > 0 ? (<span class={[`${this.cssPrefix}__item__slash`]}>/</span>) : null;
          const iconNode = !!item.icon ? (
            <span class={[`${this.cssPrefix}__item__icon`]}>
              <sw-icon props-name={item.icon} props-size={18} props-as-block />
            </span>
          ) : null;
          const textNode = !!item.text ? (
            <span class={[`${this.cssPrefix}__item__text`]}>{
              typeof item.text === 'function' ? item.text(h) : item.text
            }</span>
          ) : null;

          return (
            <div
              key={index}
              class={[
                `${this.cssPrefix}__item`, 'sw-flexbox__flex-none',
                'sw-flexbox', 'sw-flexbox--center-items',
                { [`${this.cssPrefix}__item--clickable`]: item.clickable === true },
              ]}
              on-click={() => { this.onClickItem(item, index); }}
            >
              { slashNode }
              { iconNode }
              { textNode }
            </div>
          ) as VNode;
        })
      }
      </div>
    ) as VNode;
  }
}
